<template>
  <div class="carousel-container">
    <el-carousel class="ig-carousel"
                 :height="height+'px'"
                 :autoplay="autopaly"
                 :interval="interval">
      <el-carousel-item v-for="item in list"
                        :key="item.id">
        <!-- <img :src="getUrl(item)"
             alt="loading..."> -->

        <div class="carousel-img"
             :style="{'backgroundImage':'url('+item+')'}"></div>

      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// 走马灯
export default {
  props: {
    height: {
      type: [Number, String],
      default: '300'
    },
    list: {
      type: Array,
      required: true
    },
    autopaly: {
      default: true,
      type: Boolean
    },
    interval: Number
  },
  methods: {
    getUrl (item) {
      return typeof item === 'string' ? item : item.url
    }
  },

}
</script>

<style lang="scss" scoped>
.carousel-container {
  .ig-carousel {
    img {
      object-fit: cover;
      vertical-align: top;
      width: 100%;
      height: 100%;
    }
    .carousel-img {
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }
  }
}
</style>